import type { CardCategoriesConfig } from '../../shared/types/CardCategories/CardCategoriesConfig';

export const hasManufacturerCardTypeMedicationList = (
  cardCategoriesConfig: CardCategoriesConfig,
) => {
  const matchingManufacturerCardConfig =
    cardCategoriesConfig?.find(
      (category) => category.type === 'MANUFACTURER_CARD',
    );

  return (
    Array.isArray(matchingManufacturerCardConfig?.medications) &&
    matchingManufacturerCardConfig.medications.length > 0
  );
};
